import { APIPaths } from "@/apis/api-config";
import BaseApi from "@/apis/base-api";

export class PrimaryItemTplApi extends BaseApi {
  async getPrimaryItemTplList(
    queryParameters: APIPaths["/admin-dash/primary-item-tpl/list"]["get"]["parameters"]["query"],
  ): Promise<APIPaths["/admin-dash/primary-item-tpl/list"]["get"]["responses"]["200"]["content"]["application/json"]> {
    return (await this.get("/admin-dash/primary-item-tpl/list", { params: queryParameters })).data;
  }

  async postPrimaryItemTplNew(
    requestBody: APIPaths["/admin-dash/primary-item-tpl/new"]["post"]["requestBody"]["content"]["application/json"],
  ): Promise<APIPaths["/admin-dash/primary-item-tpl/new"]["post"]["responses"]["200"]["content"]["application/json"]> {
    return (await this.post("/admin-dash/primary-item-tpl/new", requestBody)).data;
  }

  async getPrimaryItemTplById(
    pathParameters: APIPaths["/admin-dash/primary-item-tpl/{id}"]["get"]["parameters"]["path"],
  ): Promise<APIPaths["/admin-dash/primary-item-tpl/{id}"]["get"]["responses"]["200"]["content"]["application/json"]> {
    return (await this.get(`/admin-dash/primary-item-tpl/${pathParameters.id}`)).data;
  }

  async patchPrimaryItemTplById(
    pathParameters: APIPaths["/admin-dash/primary-item-tpl/{id}"]["patch"]["parameters"]["path"],
    requestBody: APIPaths["/admin-dash/primary-item-tpl/{id}"]["patch"]["requestBody"]["content"]["application/json"],
  ): Promise<
    APIPaths["/admin-dash/primary-item-tpl/{id}"]["patch"]["responses"]["200"]["content"]["application/json"]
  > {
    return (await this.patch(`/admin-dash/primary-item-tpl/${pathParameters.id}`, requestBody)).data;
  }

  async deletePrimaryItemTplById(
    pathParameters: APIPaths["/admin-dash/primary-item-tpl/{id}"]["delete"]["parameters"]["path"],
  ): Promise<
    APIPaths["/admin-dash/primary-item-tpl/{id}"]["delete"]["responses"]["200"]["content"]["application/json"]
  > {
    return (await this.delete(`/admin-dash/primary-item-tpl/${pathParameters.id}`)).data;
  }
}
